import * as React from "react"

import { APARENCIA_DE_CAMPO, DIGITADO_EM_MAIUSCULAS } from "../lib/classes"
import { cn } from "../lib/cn"

const TIPOS_SEM_MAIUSCULAS = new Set([
  "email", "password", "url", "search", "date", "datetime-local", "month", "time", "week",
])

function Input({
  className,
  type,
  maiusculas = true,
  ...props
}: React.ComponentProps<"input"> & {
  maiusculas?: boolean
}) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "h-9 w-full min-w-0 border border-input px-3 py-1 text-base text-foreground transition-[color,box-shadow] outline-none placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:text-muted-foreground md:text-sm",
        APARENCIA_DE_CAMPO,
        maiusculas && !TIPOS_SEM_MAIUSCULAS.has(type ?? "text") && DIGITADO_EM_MAIUSCULAS,
        "focus-visible:border-ring",
        "aria-invalid:border-destructive",
        "user-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  )
}

export { Input }
